import { useState, useEffect } from "react";
import Link from "next/link";
import CandidateSocialButtons from "./CandidateSocialButtons";
import styles from "../../../styles/candidate/parts/CandidateInfoSnippet.module.scss";

const CandidateInfoSnippet = ({
  header,
  details,
  context,
  isPosition,
  positionStrength,
  isSmall,
  showSocials,
  showTitleInside,
  url,
  contestName,
  candidacyId,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const loader = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
  };

  const positionStrengths = [
    "",
    "Strongly Against",
    "Against",
    "Neutral",
    "In Favor",
    "Strongly In Favor",
  ];

  const positionStrengthLocations = [
    "",
    "83.33%",
    "83.33%",
    "50%",
    "16.67%",
    "16.67%",
  ];

  return (
    <div className={`${styles.wrapper}${isSmall ? ` ${styles.small}` : ``}`}>
      {header && (header.body || (!header.body && isPosition)) && (
        <div className={styles.header}>
          {header.title && showTitleInside && (
            <h5 className={styles.headerTitle}>{header.title}</h5>
          )}
          <div
            className={`${styles.headerBody}${
              isPosition ? ` ${styles.stance}` : ""
            }`}
          >
            {isPosition && positionStrength && (
              <div className={styles.stanceContainer}>
                <p>{positionStrengths[positionStrength]}</p>
                <div
                  className={styles.stanceMeter}
                  style={{
                    "--position-strength":
                      positionStrengthLocations[positionStrength],
                  }}
                >
                  <div className={styles.stanceFor}>{"FOR"}</div>
                  <div className={styles.stanceNeutral}>{"NEUTRAL"}</div>
                  <div className={styles.stanceAgainst}>{"AGAINST"}</div>
                </div>
              </div>
            )}
            <div className={styles.headerBodyText}>
              {(header.body || "").split("<br>").map((text, index) =>
                text ? (
                  <span key={index}>
                    {text}
                    <br />
                  </span>
                ) : (
                  <br />
                )
              )}
            </div>
            {isPosition && (
              <Link
                passHref
                href={{
                  pathname:
                    "/elections/2022/races/president-vice-president/tale-of-the-tape",
                  query: {
                    selectedCandidates: `${candidacyId}`,
                    race:
                      contestName === "PRESIDENT PHILIPPINES"
                        ? "presidential"
                        : "vice-presidential",
                  },
                }}
              >
                <button className={styles.compareButton}>
                  {"COMPARE STANCE ON THIS ISSUE WITH OTHER CANDIDATES"}
                </button>
              </Link>
            )}
          </div>
          {showSocials && (
            <CandidateSocialButtons
              containerStyle={styles.socialsContainer}
              iconContainerStyle={styles.socialsContainer_img}
              loader={loader}
              url={url}
              toolTipId={"toolTip_Default"}
              isMounted={isMounted}
            />
          )}
        </div>
      )}
      {details && details.body && (
        <div className={`${styles.details} ${styles.contentBox}`}>
          {details.title && details.body && (
            <h5 className={styles.title}>{details.title}</h5>
          )}
          <div className={styles.body}>
            <p dangerouslySetInnerHTML={{ __html: details.body }} />
          </div>
        </div>
      )}
      {context && context.body && (
        <div className={`${styles.context} ${styles.contentBox}`}>
          {context.title && context.body && (
            <h5 className={styles.title}>{context.title}</h5>
          )}
          <div className={styles.body}>{context.body}</div>
        </div>
      )}
    </div>
  );
};

export default CandidateInfoSnippet;
